export const formatDateWithoutMilliseconds = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toISOString().split('.')[0] + 'Z';
};

const pad = (value: number, length = 2) => String(value).padStart(length, '0');

/** A UTC date as a datetime-local input's value (YYYY-MM-DDTHH:MM, local time), or '' if there's none */
export const toDateTimeLocalValue = (isoString: string | null | undefined): string => {
  if (!isoString) return '';
  const date = new Date(isoString);
  if (isNaN(date.getTime())) return '';
  return `${pad(date.getFullYear(), 4)}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

/**
 * Whether a date or datetime-local input's value has its whole year. Browsers report a year as it's typed, digit by
 * digit (0002, 0020, 0202, then 2026), so a year below 1000 isn't one yet.
 */
export const hasWholeYear = (value: string): boolean => /^[1-9]\d{3}-/.test(value);

/** A datetime-local input's value as a UTC date, or null until it holds a whole date, year included */
export const fromDateTimeLocalValue = (value: string): string | null => {
  if (!/^[1-9]\d{3}-\d{2}-\d{2}T\d{2}:\d{2}/.test(value)) return null;
  const date = new Date(value);
  return isNaN(date.getTime()) ? null : formatDateWithoutMilliseconds(date.toISOString());
};
